"use strict";

import angular from "angular";

import "./themes/visualization.component-dark.scss";
import "./themes/visualization.component.scss";
import template from "./visualization.component.html";

import _ from "lodash";

import { Available } from "../../../gateway/Available/Available";
import { CalculatingMachineV2Gateway } from "../../../gateway/CalculatingMachineV2Gateway/CalculatingMachineV2Gateway";
import { Point } from "../../../gateway/Point/Point";
import { PointCalculated } from "../../../gateway/PointCalculated/PointCalculated";
import { Serie } from "../../../gateway/Serie/Serie";
import { Visualization } from "../../../gateway/Visualization/Visualization";
import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";
import { CalculatingMachine } from "../../../presentation/services/CalculatingMachine/CalculatingMachine";
import { SeriesService } from "../../../presentation/services/Series/SeriesService";
import { GetNotesUsecase } from "../../../usecases";
import {
    groupedTooltipOptions,
    tooltipLine
} from "../../../utils/comparation-tooltip";
import * as DateUtils from "../../../utils/date/date";
import { FormatNumbers } from "../../../utils/format-numbers";
import {
    WINDOW_SUMMED_CHARTS,
    chartAccumulation,
    dataValuesMode,
    valueTooltip
} from "../../../utils/year-to-date-comparation";
import requestNandaIaDialogTemplate from "../../dialogs/request-nanda-ia/request-nanda-ia-dialog.html";
import configurationGoalsDialogTemplate from "../../dialogs/configuration-goals/configuration-goals-dialog.html";

class VisualizationComponent {
    showButtonConfig = true;
    fixedParameterizatonButton = false;
    user = new UserDataAdapter().user();
    constructor(
        $scope,
        $state,
        $rootScope,
        DSNDialogService,
        ParameterizationProcessService,
        ParameterizationSidenavService,
        LoaderService,
        AccountingPlanService,
        AccountingDataService
    ) {
        this.$scope = $scope;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.DSNDialogService = DSNDialogService;
        this.ParameterizationProcessService = ParameterizationProcessService;
        this.ParameterizationSidenavService = ParameterizationSidenavService;
        this.LoaderService = LoaderService;
        this.AccountingPlanService = AccountingPlanService;
        this.AccountingDataService = AccountingDataService;

        this.Visualization = new Visualization();
        this.Serie = new Serie();
        this.SeriesService = new SeriesService(this.Serie);
        this.Point = new Point();
        this.PointCalculated = new PointCalculated();
        this.Available = new Available();
        this.CalculatingMachine = new CalculatingMachine({
            Serie: this.Serie,
            Point: this.Point,
            PointCalculated: this.PointCalculated
        });
        this.calculatingMachineV2 = new CalculatingMachineV2Gateway();
        this.DashboardComparation = new DashboardComparation();

        this.series = [];
        this.seriesToChart = [];
        this.highlightsSeries = [];
        this.historicSeries = [];
        this.yearlyPoints = [];
        this.loadingTheme = false;
        this.loadingParametrization = false;
        this.isBusinessmanUser = this.user.roles.includes("Empresa");

        this.companyId = this.$state.params.id;

        const deregisterThemesService = this.$rootScope.$on(
            "THEMES_SERVICE_THEME_CHANGED",
            (event, theme) => {
                this.loading = true;
                this.loadingTheme = true;

                setTimeout(() => {
                    this.loading = false;
                    this.loadingTheme = false;
                    this.$scope.$applyAsync();
                }, 1000);
            }
        );

        this.$scope.$on("$destroy", () => {
            deregisterThemesService();
        });

        // A pizza soma o periodo no modo acumulado; a preferencia muda sem trocar binding nenhum.
        this.$scope.$on("DATA_VALUES_MODE_CHANGED", () => {
            if (
                WINDOW_SUMMED_CHARTS.includes(
                    this.visualization?.chart?.category
                )
            )
                this._setData();
        });

        this.$scope.$on("VISUALIZATION_SET_COMMENT", () => {
            if (this.visualization._id && this.showtime) {
                this.setComments();
            }
        });
    }

    onShowConfiguration(status) {
        this.showButtonConfig = status;
    }

    onOpenConfigGoals($event) {
        this.DSNDialogService.custom({
            targetEvent: $event,
            clickOutsideToClose: true,
            controller: "ConfigurationGoalsDialogCtrl as $ctrl",
            locals: {
                projection: this.projection,
                currentPeriod: this.currentPeriod,
                companyData: this.companyData,
                series: this.series,
                visualization: this.visualization,
                templateHtml: configurationGoalsDialogTemplate,
                title: "Configurar Objetivos",
                width: "448px",
                budget: this.budget
            },
            after: {
                hide: (update) => {
                    if (update) this._setData(true);
                },
                cancel: () => {}
            }
        });
    }

    $onInit() {
        if (this.visualization.loading) {
            this.loading = true;
            return;
        }

        this._setData(false, true);
    }

    $onChanges(changes) {
        if (this.visualization.loading) {
            this.loading = true;
            return;
        }

        if (!_.isEmpty(_.get(changes, "currentPeriod.previousValue") || {})) {
            this._setData();
        }

        if (
            !_.isEmpty(_.get(changes, "currentComparation.previousValue") || {})
        ) {
            this._setData();
        }

        if (
            !changes.backLayer &&
            _.get(changes, "visualization.previousValue._id") &&
            !_.isEmpty(_.get(changes, "visualization.previousValue"))
        ) {
            this._setSeries();
        }

        if (!_.isEmpty(_.get(changes, "visualization.previousValue")))
            this._setData();

        if (
            changes.currentFilterGroup &&
            !_.isEmpty(_.get(changes, "currentFilterGroup.previousValue"))
        ) {
            this._setData();
        }
    }

    async setComments() {
        const accountingEntity = this.AccountingDataService.getEntity();
        const allComments = await new GetNotesUsecase().execute({
            companyId: this.companyData._id,
            accountingId: accountingEntity.props._id,
            options: {
                period: this.currentPeriod.period,
                scenarioId: this.currentPeriod.scenario._id,
                visualizationsIds: [this.visualization._id],
                date: {
                    year: this.currentPeriod.date.getUTCFullYear(),
                    month: this.currentPeriod.date.getUTCMonth() + 1
                }
            }
        });
        this.hasComment = allComments?.[0]?._id ? true : false;
        this.$scope.$applyAsync();
    }

    _setData(loading) {
        this.loading = loading;

        this._setSeries();
        this._setPoints();

        const runningTimeOut = setTimeout(() => {
            this.loading = false;
            this.$scope.$applyAsync();
        }, 500);

        this.$scope.$on("$destroy", () => {
            clearTimeout(runningTimeOut);
        });

        if (this.visualization._id && this.showtime) this.setComments();

        if (this.visualization.chart) {
            this.visualization.chart.tooltip = this.getTooltip();
        }
    }

    /**
     * @private
     * Multiplica o mes de acordo com periodo
     * @param {String} period
     * @param {Number} months
     * @returns
     */
    _getStartDate(period, months = 12) {
        const multiplier = {
            monthly: 1,
            quarterly: 3,
            semester: 6,
            yearly: 12
        };

        return multiplier[period] * months;
    }

    /**
     * A janela da pizza no modo acumulado (ver `chartAccumulation`), com as series COMPLETAS do
     * minimongo: as do grafico vem sem `sources`/`genus`/`classifier`, que decidem quem soma.
     */
    _setChartAccumulation() {
        const category = this.visualization?.chart?.category;
        if (!WINDOW_SUMMED_CHARTS.includes(category)) {
            this.chartAccumulation = null;
            return;
        }
        const ids = Array.isArray(this.visualization.series)
            ? this.visualization.series
            : [];
        this.chartAccumulation = chartAccumulation({
            category,
            mode: dataValuesMode(this.companyData?.preferences),
            period: this.currentPeriod,
            comparation: this.currentComparation,
            budget: Boolean(this.budget),
            fakeData: Boolean(this.fakeData),
            visualizationAccumulated: Boolean(this.isAccumulated),
            series: ids.length
                ? this.Serie.findCollection(
                      { _id: { $in: ids } },
                      {},
                      "array"
                  )
                : []
        });
    }

    _setPoints() {
        this._setChartAccumulation();
        let startDate =
            +this.currentComparation.date < +this.currentPeriod.startDate
                ? this.currentComparation.date
                : this.currentPeriod.startDate;
        if (!startDate) startDate = this.currentComparation.date;
        let endDate =
            +this.currentComparation.date > +this.currentPeriod.date
                ? this.currentComparation.date
                : this.currentPeriod.date;
        const scenarioId = this.currentPeriod.scenario._id;
        const source = this.visualization.sources[0];
        const companyId = this.$state.params.id;
        const allDates = this.Available.get({
            companyId,
            scenarioId,
            source: source,
            options: {
                projection: this.projection,
                budget: this.budget,
                separatted: true
            }
        });
        const available = allDates.allDates;
        this.CalculatingMachine.setSource(source);
        const ignoreAvailable = _.get(
            this.visualization,
            "metadata.ignoreAvailable"
        );
        const seriesIds = [
            ...(Array.isArray(this.visualization.series)
                ? this.visualization.series
                : []),
            _.get(this.visualization, "highlightsSeriesIds")
        ].filter((s) => s);
        const params = {
            companyId: this.$state.params.id,
            serieIds: _.uniq(seriesIds),
            scenario: scenarioId,
            period: this.currentPeriod.period,
            fakeData: this.fakeData,
            isGroupCompanies: _.get(this.companyData, "isGroup"),
            options: {
                ignoreAvailable,
                groupFilterOper: this.currentFilterGroup,
                totalGroupCompanies: _.get(
                    this.companyData,
                    "companyIds.length",
                    0
                ),
                recalculate: true,
                visualizationAccumulated: this.isAccumulated
            }
        };
        if (!ignoreAvailable) {
            if (this.currentComparation.allMonths) {
                const startYear = this.currentComparation.date.getUTCFullYear();
                const endYear = this.currentPeriod.date.getUTCFullYear();
                params.timesBetween = {
                    startDate: new Date(`${startYear}/01/01`),
                    endDate: new Date(`${endYear}/12/01`)
                };
            } else {
                params.timesBetween = {
                    startDate,
                    endDate
                };
            }
        }
        let timesBetweenInAvailable = params.timesBetween;
        if (this.fakeData) {
            const currentYear = new Date().getUTCFullYear();
            timesBetweenInAvailable = {
                startDate: new Date(currentYear + "/01/01"),
                endDate: new Date(currentYear + "/12/01")
            };
        }
        if (this.budget)
            timesBetweenInAvailable = {
                startDate: DateUtils.getDate(
                    _.head(allDates.availableDates) || _.head(allDates.allDates)
                ),
                endDate: DateUtils.getDate(
                    _.last(allDates.availableDates) || _.last(allDates.allDates)
                )
            };
        const pointsResult = this.CalculatingMachine.result({
            ...params,
            timesBetween: timesBetweenInAvailable
        });
        if (
            this.currentComparation.allMonths ||
            this.currentComparation.indicatorValuesYearly
        ) {
            this.CalculatingMachine.result({
                ...params,
                period: "yearly"
            });
        }
        let pointsScenario = [];
        if (
            this.currentComparation.scenario._id !=
                this.currentPeriod.scenario._id ||
            (this.currentComparation?.scenario?.options?.projection &&
                this.currentComparation?.scenario?.options?.projection !=
                    this.currentPeriod?.scenario?.options?.projection)
        ) {
            pointsScenario = this._getPointsScenario({
                params,
                scenarioId: this.currentComparation.scenario._id,
                source,
                options: _.get(this.currentComparation, "scenario.options", {})
            });
        }

        if (this.budget) {
            pointsScenario = this.CalculatingMachine.result({
                ...params,
                scenario: this.budget
            });
        }

        let pointsGoals = [];
        let goalsIds = [];

        if (this.goals && this.visualization?.goals?.length) {
            goalsIds = this._getGoalsIds(source);
            if (goalsIds?.length) {
                pointsGoals = this.CalculatingMachine.result({
                    ...params,
                    serieIds: goalsIds,
                    timesBetween: {
                        startDate,
                        endDate
                    }
                });
            }
        }
        const allPoints = [...pointsResult, ...pointsScenario, ...pointsGoals];
        if (this.fakeData) {
            this.pointsData = allPoints;
            return;
        }
        if (this.currentPeriod.period != "monthly") {
            const responsePoints = this.CalculatingMachine.formatPeriodPoints(
                allPoints,
                available,
                this.currentPeriod.period,
                [...params.serieIds, ...goalsIds],
                scenarioId
            );
            const points = this.CalculatingMachine.filterPoints(
                responsePoints,
                startDate,
                endDate,
                this.currentPeriod.period
            );
            this.pointsData = this.DashboardComparation.filterPointsByComparation(
                {
                    points,
                    period: this.currentPeriod,
                    comparation: this.currentComparation,
                    allMonths: false,
                    available: allDates.allDates
                }
            );
            this.setFixedParameterizatonButton();
            return true;
        }

        let points = [];

        if (
            !this.currentComparation.allMonths &&
            !this.currentComparation.active
        ) {
            points = this.CalculatingMachine.filterPoints(
                allPoints,
                startDate,
                endDate,
                this.currentPeriod.period,
                ignoreAvailable
            );
        } else points = allPoints;

        this.pointsData = this.DashboardComparation.filterPointsByComparation({
            points,
            period: this.currentPeriod,
            comparation: this.currentComparation,
            allMonths: this.currentComparation.allMonths,
            available: allDates.allDates
        });
        this.setFixedParameterizatonButton();
    }

    setFixedParameterizatonButton() {
        const allPointsAreZero = this.pointsData.every((p) => p.m?.v == 0);
        this.fixedParameterizatonButton = allPointsAreZero;
    }

    _getGoalsIds(source) {
        return this.SeriesService.getGoalsIds({
            source,
            series: this.series,
            visualization: this.visualization
        });
    }

    _getPointsScenario({ params, scenarioId, source, options = {} }) {
        const available = this.Available.get({
            companyId: this.$state.params.id,
            scenarioId,
            source,
            options
        });
        const firstDate = _.head(available);
        const lastDate = _.last(available);
        const _startDate = new Date(firstDate);
        const monthStart = _startDate.getUTCMonth() + 1;
        const _endDate = new Date(lastDate);
        const monthEnd = _endDate.getUTCMonth() + 1;
        const startDate = new Date(
            `${_startDate.getUTCFullYear()}/${String(monthStart).padStart(
                2,
                "0"
            )}/01`
        );
        const endDate = new Date(
            `${_endDate.getUTCFullYear()}/${String(monthEnd).padStart(
                2,
                "0"
            )}/01`
        );
        const response = this.CalculatingMachine.result({
            ...params,
            scenario: scenarioId,
            timesBetween: {
                startDate,
                endDate
            }
        });
        return response;
    }

    /**
     * @private
     * Retorna as series
     * @param { Object|Array } seriesIds
     * @returns { Array }
     */
    _getSeries(seriesIds = _.get(this.visualization, "series")) {
        const series = this.SeriesService.getByByIds(seriesIds);
        if (!series?.length && this.fakeData)
            return this.visualization.chart.series;
        return series;
    }

    modelerGoalsSeries({
        visualizationGoals,
        goalsSeries,
        defaultSeries
    } = {}) {
        const goalsSeriesReference = goalsSeries.map((serie) => {
            const visualizationGoal = visualizationGoals.find((goal) => {
                if (serie.sources === "accounting")
                    return goal.r === serie?.referenceId;
                return goal.r === serie._id;
            });
            return {
                ...serie,
                goalSerieId: visualizationGoal?.s
            };
        });
        const series = [];
        defaultSeries.forEach((serie) => {
            series.push(serie);
            const goalSerie = goalsSeriesReference.find(
                (s) => s.goalSerieId === serie._id
            );
            if (goalSerie) {
                goalSerie.name = `Objetivo - `;
                goalSerie.name_nd = `Objetivo -`;
                goalSerie.linkedTo = serie._id;
                series.push(goalSerie);
            }
        });
        return series;
    }

    _setSeries() {
        this.series = this._getSeries();
        if (this.visualization.highlightsSeriesIds)
            this.highlightsSeries = this._getSeries(
                this.visualization.highlightsSeriesIds
            );
        if (this.goals && this.visualization?.goals?.length) {
            const goalSeries = this._getSeries(this._getGoalsIds());
            this.series = this.modelerGoalsSeries({
                visualizationGoals: this.visualization.goals,
                goalsSeries: goalSeries,
                defaultSeries: [...this.series, ...this.highlightsSeries]
            });
        }
        if (this.visualization.historic) this._setHistoricSeries();
        this.seriesData = this._seriesModeler(this.series);
    }

    _setHistoricSeries() {
        const historic = this.visualization.historic.map((s) => {
            return s.dataSerieId;
        });
        let historicSeries = [];

        historicSeries = this._getSeries(historic);

        this.historicSeries = this._seriesModeler(historicSeries);
    }

    _seriesModeler(series = []) {
        return series.map((serie) => {
            return {
                _id: serie._id,
                name: serie.name,
                origin: serie?.metadata?.origin || serie.type,
                name_nd: serie.name,
                metadata: serie?.metadata || {},
                unit: serie.unit,
                description: serie.description,
                referenceId: serie.referenceId,
                polarity: serie.polarity || 0,
                linkedTo: serie.linkedTo
            };
        });
    }

    /**
     * Check if showing chart or not depending on the section height
     * @param { Number } width width of the visualization
     * @param { Number } height height of the section
     * @param { Object } rules width and height rules
     * @return { Boolean } show
     */
    visualizationRule(
        width = this.columnWidth,
        height = this.rowHeight,
        rules = this.visualization.rules
    ) {
        if (!height) return true;
        if (!rules) return true;
        if (rules) {
            let widthOk, heightOk;
            if (rules.width) {
                widthOk = rules.width.indexOf(width) != -1;
            } else {
                widthOk = true;
            }
            if (rules.height) {
                heightOk = rules.height.indexOf(height) != -1;
            } else {
                heightOk = true;
            }
            return widthOk && heightOk;
        }
        return height >= 50;
    }

    refreshData() {
        this._setData();
    }

    getTooltip() {
        const formatNumbers = FormatNumbers;
        const chartType = this.visualization.chart.category;
        const _toLocaleUnit = (unit, value) => {
            if (unit === "percentage") {
                return (value / 100).toLocaleString("pt-BR", {
                    style: "percent",
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2
                });
            } else {
                return formatNumbers.byUnit(unit, value);
            }
        };
        /*
         * Comparacao "todos os meses" e orcamento poem os DOIS lados no mesmo mes. Sem titulo, o
         * tooltip repetia cada nome duas vezes e nao dava para saber qual valor era de qual ano —
         * ver `groupTooltipPoints`.
         */
        const budget = Boolean(this.budget);
        const doisLadosNoMesmoMes =
            (this.currentComparation?.allMonths || budget) &&
            !["waterfall", "pie", "gauge"].includes(chartType);
        if (doisLadosNoMesmoMes) return groupedTooltipOptions({ budget });

        // "Acumulado de Jun/2025 até Jun/2026" embaixo do titulo, como no tooltip do card.
        const acumulado = this.chartAccumulation;
        const periodoAcumulado = acumulado
            ? `<span style="font-size: 11px">${valueTooltip(
                  acumulado,
                  true
              )}</span><br>`
            : "";
        return {
            headerFormat: `<b>{point.key}</b><br>${periodoAcumulado}`,
            pointFormatter: function () {
                if (["waterfall", "pie", "gauge"].includes(chartType)) {
                    let tooltipContent = ``;
                    this.series.chart.series[0].data.forEach((point, index) => {
                        const percentage =
                            point.percentage && chartType !== "gauge"
                                ? `(${(point.percentage / 100).toLocaleString(
                                      "pt-BR",
                                      {
                                          style: "percent",
                                          maximumFractionDigits: 2,
                                          minimumFractionDigits: 2
                                      }
                                  )})`
                                : "";
                        tooltipContent += `<span style="color:${
                            point.color
                        };">● </span> ${
                            point.name
                        } ${percentage}: <b>${_toLocaleUnit(
                            point.unit,
                            point.y,
                            1
                        )}</b><br/>`;
                    });
                    return tooltipContent;
                } else {
                    return tooltipLine(this.series, this.y);
                }
            },
            xDateFormat: "%B de %Y",
            shared: true
        };
    }

    async onOpenParametrization() {
        this.LoaderService.setProgress(true);
        this.loadingParametrization = true;
        await this.ParameterizationSidenavService.open({
            companyData: this.companyData,
            series: this.series
        });
        this.ParameterizationSidenavService.setVisualizationSelected(
            this.visualization
        );
        this.loadingParametrization = false;
        this.LoaderService.setProgress(false);
    }

    onAnalyzeWithIA() {
        if (
            !this.AccountingPlanService.features.IAShortcutsAccounting &&
            this.companyId !== "EMPRESA_MODELO"
        ) {
            this.DSNDialogService.custom({
                controller: "RequestNandaIADialogCtrl",
                locals: {
                    accountingEntity: this.AccountingDataService.getEntity(),
                    pkge: "Atalhos da IA do Contador",
                    title: "Nanda IA",
                    rocketIcon: true,
                    templateHtml: requestNandaIaDialogTemplate,
                    width: "380px"
                },
                after: {
                    hide: async () => {},
                    cancel: () => {}
                }
            });
            return;
        }
        this.$rootScope.$emit("IA_NANDA_OPEN");
        setTimeout(() => {
            this.$rootScope.$emit(
                "IA_ANALYZE_VISUALIZATION",
                this.visualization
            );
        }, 1000);
    }
}

export class DashboardComparation {
    constructor() {}
    filterPointsByComparation({
        points,
        comparation,
        period,
        allMonths,
        available
    } = {}) {
        if (!comparation || !comparation.active) {
            if (+period.startDate === +period.date && available.length > 1) {
                return points.filter(
                    (p) =>
                        `${p.t.getUTCFullYear()}/${p.t.getUTCMonth()}` !=
                        `${comparation.date.getUTCFullYear()}/${comparation.date.getUTCMonth()}`
                );
            }
            return points;
        }
        const filteredPoints = [];
        if (allMonths) {
            const comparationYear = comparation.date.getUTCFullYear();
            const periodYear = period.date.getUTCFullYear();
            for (const point of points) {
                const pointYear = point.t.getUTCFullYear();
                if (pointYear === comparationYear || pointYear === periodYear) {
                    this.insertPointInOrder(filteredPoints, point);
                }
            }
        } else {
            const periodTimestamp = period.date.getTime();
            const comparationTimestamp = comparation.date.getTime();
            for (const point of points) {
                const pointTimestamp = point.t.getTime();
                if (
                    (pointTimestamp === periodTimestamp &&
                        point.sc === period.scenario._id) ||
                    (pointTimestamp === comparationTimestamp &&
                        point.sc === comparation.scenario._id)
                ) {
                    this.insertPointInOrder(filteredPoints, point);
                }
            }
        }
        return filteredPoints;
    }
    insertPointInOrder(pointsArray, point) {
        const index = pointsArray.findIndex((element) => element.t > point.t);
        if (index === -1) {
            pointsArray.push(point);
        } else {
            pointsArray.splice(index, 0, point);
        }
    }
}

export { VisualizationComponent };

VisualizationComponent.$inject = [
    "$scope",
    "$state",
    "$rootScope",
    "DSNDialogService",
    "ParameterizationProcessService",
    "ParameterizationSidenavService",
    "LoaderService",
    "AccountingPlanService",
    "AccountingDataService"
];

const name = "visualizationIndicatorComponent";
const def = {
    bindings: {
        visualization: "<",
        currentPeriod: "<",
        currentComparation: "<",
        source: "<",
        projection: "<",
        budget: "<",
        goals: "<",
        columnWidth: "<",
        rowHeight: "<",
        fakeData: "<",
        backLayer: "<",
        isAccumulated: "<",
        options: "<",
        currentFilterGroup: "<",
        companyData: "<",
        labelCompanyName: "<",
        companyTooltip: "<",
        hideChartTooltip: "<",
        specialConfigs: "<",
        onOpenNotes: "&",
        showtime: "<",
        isReport: "<",
        isDrilldown: "<"
    },
    controller: VisualizationComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
